var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var valid = ref.valid
              return [
                _c(
                  "b-form",
                  {
                    class: [_vm.inline ? "gap-2 items-center" : ""],
                    attrs: { inline: _vm.inline },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.addDestination($event)
                      },
                      reset: function($event) {
                        $event.preventDefault()
                        return _vm.clearForm($event)
                      }
                    }
                  },
                  [
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t(
                          "reporting_channel.workflow_config.destinations.name"
                        ),
                        rules: "required",
                        slim: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(validationContext) {
                              return [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: _vm.$t(
                                        "reporting_channel.workflow_config.destinations.name"
                                      ),
                                      "label-for": "destination_name"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "required",
                                      attrs: {
                                        id: "destination_name",
                                        placeholder: _vm.$t(
                                          "reporting_channel.workflow_config.destinations.name"
                                        )
                                      },
                                      model: {
                                        value: _vm.destination.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.destination, "name", $$v)
                                        },
                                        expression: "destination.name"
                                      }
                                    }),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { class: [{ absolute: _vm.inline }] },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              validationContext.errors[0]
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t(
                          "reporting_channel.workflow_config.destinations.email"
                        ),
                        rules: "required|email",
                        slim: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(validationContext) {
                              return [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-2",
                                      label: _vm.$t(
                                        "reporting_channel.workflow_config.destinations.email"
                                      ),
                                      "label-for": "destination_email"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "required",
                                      attrs: {
                                        id: "destination_email",
                                        type: "email",
                                        placeholder: _vm.$t(
                                          "reporting_channel.workflow_config.destinations.email"
                                        )
                                      },
                                      model: {
                                        value: _vm.destination.email,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.destination,
                                            "email",
                                            $$v
                                          )
                                        },
                                        expression: "destination.email"
                                      }
                                    }),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { class: [{ absolute: _vm.inline }] },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              validationContext.errors[0]
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm.destination
                      ? _c(
                          "b-form-group",
                          {
                            staticClass: "flex-grow",
                            attrs: {
                              id: "input-group-3",
                              label: _vm.$t(
                                "reporting_channel.deadline_config.handling_status"
                              ),
                              "label-for": "destination_handling_status"
                            }
                          },
                          [
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  options: _vm.handlingStatusOptions,
                                  reduce: function(option) {
                                    return option.key
                                  },
                                  "get-option-label": function(option) {
                                    return option ? option.label : ""
                                  },
                                  placeholder:
                                    "Selecione o(s) status (opcional)",
                                  clearable: true,
                                  multiple: "",
                                  "close-on-select": false
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selected-option-container",
                                      fn: function(ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class: _vm.isHexColor(
                                                option.color
                                              )
                                                ? "badge badge-glow"
                                                : "badge badge-glow badge-" +
                                                  (option.color || "secondary"),
                                              style: _vm.isHexColor(
                                                option.color
                                              )
                                                ? "background-color: " +
                                                  option.color +
                                                  "; margin-right: 4px; margin-bottom: 2px; display: inline-block;"
                                                : "margin-right: 4px; margin-bottom: 2px; display: inline-block;"
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(option.label) + " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class: _vm.isHexColor(
                                                option.color
                                              )
                                                ? "badge badge-glow"
                                                : "badge badge-glow badge-" +
                                                  (option.color || "secondary"),
                                              style: _vm.isHexColor(
                                                option.color
                                              )
                                                ? "background-color: " +
                                                  option.color +
                                                  "; margin-right: 8px;"
                                                : "margin-right: 8px;"
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(option.label) + " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.destination.handling_status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.destination,
                                      "handling_status",
                                      $$v
                                    )
                                  },
                                  expression: "destination.handling_status"
                                }
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _c("span", [
                                    _vm._v("Nenhuma situação encontrada")
                                  ])
                                ])
                              ],
                              2
                            ),
                            _vm.errors && _vm.errors.handling_status
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.errors.handling_status[0]))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "flex flex-row justify-end gap-4" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value:
                                  "reporting_channel_handling.configuration.destinations.create",
                                expression:
                                  "\n            `reporting_channel_handling.configuration.destinations.create`\n          "
                              },
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "px-1",
                            attrs: {
                              variant: "outline-primary",
                              disabled: !valid
                            },
                            on: { click: _vm.addDestination }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "PlusIcon" }
                            }),
                            _c("span", { staticClass: "align-middle" }, [
                              _vm._v(_vm._s(_vm.$t("add")))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "px-1",
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function($event) {
                                return _vm.$bvModal.show("search-contact")
                              }
                            }
                          },
                          [
                            _c("b-icon-search", { staticClass: "mr-50" }),
                            _c("span", { staticClass: "align-middle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("action.search_contact") ||
                                    "Buscar Contato"
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm.service && _vm.id
        ? _c(
            "div",
            { staticClass: "vs-row w-full pt-2" },
            [
              _c("Grid", {
                ref: "grid-destination",
                attrs: {
                  hide_actions: false,
                  service: _vm.service,
                  route_grid_path: "/" + _vm.id + "/destinations/grid",
                  route_name: "handling_status_configuration_index",
                  order_column: "name",
                  direction: "asc",
                  column_formats: _vm.columnFormats
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "actions",
                      fn: function(actions) {
                        return [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value:
                                  "reporting_channel_handling.configuration.destinations.delete",
                                expression:
                                  "\n            `reporting_channel_handling.configuration.destinations.delete`\n          "
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Remover destinatário",
                                expression: "'Remover destinatário'"
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function($event) {
                                return _vm.confirmDeleteDestination(actions.row)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4239816184
                )
              }),
              _c(
                "div",
                { staticClass: "flex flex-row justify-end gap-4 mt-3" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.handleBack }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("action.back")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("calendar-contact-popup", { on: { selected: _vm.addContactList } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }